import HCheckArray from "@rf-helper/check-have-value";
import { IPropertyDraftListFilterSchema } from "../pages/draft-list/util/propertyDraftListFilter";
import { DraftListValuesQRTK } from "@/src-refactor/modules/store/qrtk/services/property-draft/values/draft-list.values";

const propertyDraftListFilterAdapter = (
  data: IPropertyDraftListFilterSchema
): DraftListValuesQRTK["query"] => {
  return {
    page: data.page,
    draft_type: HCheckArray(data.typeDraft) ? data.typeDraft[0].value : undefined
  };
};

export default propertyDraftListFilterAdapter;
